import { render } from "./PredictionComplete.vue?vue&type=template&id=02745a1c"
import script from "./PredictionComplete.vue?vue&type=script&lang=js"
export * from "./PredictionComplete.vue?vue&type=script&lang=js"

import "./PredictionComplete.vue?vue&type=style&index=0&id=02745a1c&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__